import * as React from 'react';



export default class Delete extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd">
            <path className="binStroke" stroke="none" fill="#42ABEF" d="M10 2h2v11h-2z"/>
            <path stroke="none" fill="#333" fillRule="nonzero" d="M5.667 1v.8h2.666V1H5.667zm0-1h2.666a1 1 0 0 1 1 1v.8a1 1 0 0 1-1 1H5.667a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"/>
            <path stroke="none" fill="#333" fillRule="nonzero" d="M2.867 2.867V13h8.266V2.867H2.867zm0-1h8.266a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H2.867a1 1 0 0 1-1-1V2.867a1 1 0 0 1 1-1z"/>
            <path stroke="none" fill="#333" fillRule="nonzero" d="M4.633 4.633h1v6.6h-1zM8.367 4.633h1v6.6h-1zM.467 2.833a.5.5 0 1 1 0-1h13.066a.5.5 0 1 1 0 1H.467z"/>
        </g>
      </svg>
    )
  }
}
